"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageStatusSchema = exports.PackageStatus = void 0;
const z = require("zod");
var PackageStatus;
(function (PackageStatus) {
    PackageStatus["Draft"] = "draft";
    PackageStatus["Published"] = "published";
})(PackageStatus || (exports.PackageStatus = PackageStatus = {}));
exports.packageStatusSchema = z.nativeEnum(PackageStatus);
//# sourceMappingURL=package-status.js.map